module.exports = __webpack_public_path__ + "img/measuring-instructions.a021ecea.jpg";